export default __webpack_public_path__ + "static/media/arrow-left.46c432b7.png";